var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.5,3.5c0.3-0.2,0.6-0.4,1-0.6c0.6-0.4,1.3-0.6,1.8-0.8C7.5,2,7.7,2,7.9,2c1.4-0.1,2.9-0.1,4.4-0.1 c1.5,0,2.9,0,4.3,0.1c0.4,0,0.7,0.1,1,0.3c0.4,0.2,0.7,0.4,1.1,0.6c0.3,0.2,0.6,0.4,0.8,0.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.1,
    y1: 7.9,
    x2: 19.1,
    y2: 7.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.1,
    y1: 13.5,
    x2: 19.1,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.3,
    y1: 7.9,
    x2: 9.3,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.8,
    y1: 7.9,
    x2: 14.8,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.1,
    cy: 16.7,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.2,19.9H8.1c-1.8,0-3.2-1.5-3.2-3.2V8.5c0-1.8,1.5-3.2,3.2-3.2h8.1c1.8,0,3.2,1.5,3.2,3.2v8.1 C19.5,18.4,18,19.9,16.2,19.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.4,
    y1: 19.9,
    x2: 6.1,
    y2: 22.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.8,
    y1: 19.9,
    x2: 18.1,
    y2: 22.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram);
export default __webpack_public_path__ + "static/media/tram.134d2659a4726ee1890b1761decba55f.svg";
export { ForwardRef as ReactComponent };